module.exports = __webpack_public_path__ + "img/jewelry.d7459b7.webp";